export const GeneralTaskFrequency = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY",
};

export const GeneralTaskStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETE: "COMPLETE",
  CANCEL: "CANCEL",
};
export const DAYS_OF_WEEK = [
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
  { value: 7, label: "Sunday" },
];

export const DAYS_OF_MONTH = Array.from({ length: 31 }, (_, i) => ({
  value: i + 1,
  label: (i + 1).toString(),
}));

export const STATUS_LIST = [
  {
    value: GeneralTaskStatus.PENDING,
    label: "Pending",
    color: "#F3AF3D",
    background: "#FEF7EC",
  },
  {
    value: GeneralTaskStatus.IN_PROGRESS,
    label: "In Progress",
    color: "#1576BC",
    background: "#E8F1F8",
  },
  {
    value: GeneralTaskStatus.COMPLETE,
    label: "Complete",
    color: "#3EBB3E",
    background: "#ECF8EC",
  },
  {
    value: GeneralTaskStatus.CANCEL,
    label: "Cancel",
    color: "#EF3948",
    background: "#FDEBED",
  },
];

export const DATE_FORMAT = "DD/MM/YYYY";
